<script setup lang="ts">
import { useModalStore } from "@/stores/modals/modals.store";

// Opened by useAutoMapLeaveGuard when the user navigates away from Material Mapping with an
// Auto mapping preview still pending. Resolves the store's promise with
// `{ action: "accept" | "discard" }`; Esc, the backdrop and ModalRoot's own close (X) button
// resolve with nothing, which the guard reads as "stay" — so this modal doesn't need its own
// Stay button, and ModalRoot's default auto-focus lands on that X, the safe no-op choice.
defineProps<{
  label: string;
}>();

const modals = useModalStore();

const choose = (action: "accept" | "discard") => modals.close({ action });

const buttonBase =
  "focus-ring interactive-active t-small-bold duration-fast ease-standard inline-flex items-center justify-center gap-2 rounded-8 px-4 py-2 transition-colors";
</script>

<template>
  <div class="space-y-px-24 flex flex-col">
    <h4 class="t-h4 text-type-default">Leave with proposed mappings?</h4>
    <span>{{ label }}. Leaving without accepting discards them.</span>

    <div class="gap-px-8 flex justify-end">
      <button
        type="button"
        :class="[buttonBase, 'bg-slate-200 text-slate-600 hover:bg-slate-300']"
        @click="choose('discard')">
        Discard and leave
      </button>
      <button
        type="button"
        :class="[
          buttonBase,
          'bg-app-blue-600 dark:bg-app-blue-fill hover:bg-app-blue-700 dark:hover:bg-app-blue-fill-hover text-white',
        ]"
        @click="choose('accept')">
        Accept and leave
      </button>
    </div>
  </div>
</template>
